(function () {
  document.addEventListener('change', function (e) {
    var select = e.target.closest('.ed-card-variant-select');
    if (!select) return;
    var card = select.closest('[data-ed-card]');
    if (!card) return;
    card.setAttribute('data-ed-selected-variant', select.value);
  });

  document.addEventListener('click', function (e) {
    var quickAddBtn = e.target.closest('[data-ed-quickadd]');
    if (!quickAddBtn) return;
    e.preventDefault();
    var card = quickAddBtn.closest('[data-ed-card]');
    if (!card) return;
    var variantId = card.getAttribute('data-ed-selected-variant');
    if (!variantId) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    quickAddBtn.disabled = true;
    quickAddBtn.classList.add('loading');

    var body = {
      items: [{ id: variantId, quantity: 1 }],
    };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (response) {
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        var url = quickAddBtn.getAttribute('data-ed-product-url');
        if (url) window.location.href = url;
      })
      .finally(function () {
        quickAddBtn.disabled = false;
        quickAddBtn.classList.remove('loading');
      });
  });
})();
